import React, { useEffect } from 'react';
import s from './s.module.less';
import useGetPPAServiceSpecialtyList from 'hooks/useGetPPAServiceSpecialtyList';
import { Form, Spin } from 'antd';
import { EPPAStep, IPPAServiceDetailResponse, IPPAServiceSpecialty } from 'types/ppaOnboarding';
import SpecialtySelector from 'components/SpecialtySelector';

interface IProps {
    formId?: string;
    onNext?: (data: any, step: EPPAStep) => void;
    setNextButtonDisabled?: (disabled: boolean) => void;
    serviceDetail?: IPPAServiceDetailResponse;
    wrapClassName?: string;
}

const Step2 = ({ formId, onNext, setNextButtonDisabled, serviceDetail, wrapClassName }: IProps) => {
    const [form] = Form.useForm();
    const [specialties, loading] = useGetPPAServiceSpecialtyList();
    const specialtyVal = Form.useWatch('specialty', form);

    useEffect(() => {
        if (serviceDetail) {
            form.setFieldsValue({
                specialty: specialties.find((item) => item.specialtyName === serviceDetail.selectedSpecialty),
            });
        }
    }, [serviceDetail, form, specialties]);

    useEffect(() => {
        setNextButtonDisabled?.(!specialtyVal);
    }, [specialtyVal, setNextButtonDisabled]);

    const handleFormFinish = (values: { specialty: IPPAServiceSpecialty }) => {
        onNext?.(
            {
                recordType: 'KLARITY_ONBOARDING_SPECIALTY',
                value: values.specialty.specialtyName,
            },
            EPPAStep.STEP_6,
        );
    };

    if (loading) {
        return <Spin spinning />;
    }

    return (
        <div className={`${s.wrap} ${wrapClassName || ''}`}>
            <div className={s.header}>
                <h1>Select one specialty to set up first</h1>
                <p>
                    Selecting a specialty helps us list your services where the right patients can find you quickly. You
                    can add or edit specialties anytime.
                </p>
                <Form form={form} id={formId} layout="vertical" onFinish={handleFormFinish}>
                    <Form.Item name="specialty" rules={[{ required: true, message: 'Please select a specialty!' }]}>
                        <SpecialtySelector specialties={specialties} />
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default Step2;
